<div [ngClass]="{'mox-ui-page-container': claim.isMox()}">
  <div class="prev-bar">
    <a (click)="back()" style="color: #0064c1" class="btn new-btn btn-secondary"><i class="fas fa-arrow-left"></i>&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.back' | translate}}&nbsp;</a>
    <a (click)="back()" *ngIf="claim.isMox()" class="back-chevron"></a>
  </div>
  <div class="col-12">
    <h5>{{ 'claimSection.generalLabels.whatHappened' | translate}}</h5>
    <p>{{ 'claimSection.tripCurtailment.extraCost.title' | translate}}</p>
  </div>
  <BR>
  <div class="row col-12">
    <div class="col-lg-9 col-md-12" [ngClass]="{'mox-ui-full-width': claim.isMox()}">

      <form>
        <div>
          <div class="form-group">
            <qnect-ui #TRAVEL_CURTAILMENT9 [fieldId]="'TRAVEL_CURTAILMENT9'" [formGroup]="travelExtralCostForm" name="hasTranExtraCost"></qnect-ui>
          </div>
          <div class="form-group click-more-content" id="q1" [hidden]="!this.tripCurtailment.getHasTransExtraCost()">
              <qnect-ui #TRAVEL_CURTAILMENT10 [fieldId]="'TRAVEL_CURTAILMENT10'" [formGroup]="travelExtralCostForm" name="extraTransCostVal"></qnect-ui>
          </div>
        </div>
        <div>
          <div class="form-group">
              <qnect-ui #TRAVEL_CURTAILMENT11 [fieldId]="'TRAVEL_CURTAILMENT11'" [formGroup]="travelExtralCostForm" name="hasAccomExtraCost"></qnect-ui>
          </div>
          <div class="form-group click-more-content" id="q2" [hidden]="!this.tripCurtailment.getHasAccomExtraCost()">
              <qnect-ui #TRAVEL_CURTAILMENT12 [fieldId]="'TRAVEL_CURTAILMENT12'" [formGroup]="travelExtralCostForm" name="extraAccomCostVal"></qnect-ui>
          </div>
        </div>
      </form>

    </div>
    <div class="col-lg-3 col-xl-3 col-md-12">
      &nbsp;
    </div>
  </div>
  <div class="submit-bar">
    <abandon-button></abandon-button>
    <a href="javascript:;" (click)="showModal()" [hidden]="claim.isMox()" class="Tertiary"> {{ 'claimSection.generalLabels.generalButtonLabels.save' | translate}}</a>
    <a (click)="goToNext()"  href="javascript:;" class="new-btn btn btn-primary float-right">&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.next' | translate}}&nbsp;<i class="fas fa-arrow-right"></i></a>
  </div>
  <app-save-box [showTotalBox]="showTotalBox" (childEvent)="getData($event)"></app-save-box>
</div>
